import { useMemo } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import ErrorMessageBox from "../components/ErrorMessageBox";
import { Loading } from "../components/Loading";
import { Pagination } from '../components/Pagination';
import BookListItem from "./components/BookListItem";
import { useGetBookSearch } from "./useGetBookSearch";
import { useQuery } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { BookSearchOption } from "./BookSearchOption";
const queryString = require('query-string');

export const BookList = ()=>{
    const {school} = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const searchOption = useGetBookSearch();

    const { data:bookList, isFetching, isError, error } = useQuery({
        queryKey:['books', searchOption],
        queryFn:()=>{
            const search_keyword = searchOption.search_keyword.replace(/(\s*)/g, "");
            return Api.post(`/api/book/list?page=${searchOption.page}&sort=${searchOption.sort}`, {...searchOption, search_keyword});
        }
    });
    function gotoPage(page, newOption={}){
        const tempOption = {...searchOption, ...newOption, page:page};
        navigate({ pathname: `/${school}/book`, search: "?" + queryString.stringify(tempOption) });
    }
    
    const BookListElements = useMemo(() => {
        if( isError ) return <ErrorMessageBox message={ createFetchErrorMessage(error).message} />;
        if(  bookList?.data?.list.length===0){
            return (
                <div className="guide">
                    <p className="alignC orange"><i className="icon fas fa-exclamation-circle"></i> 연관 도서 정보가 없습니다.<br/>다시 검색해 주세요.</p>
                </div>
            )  
        }
        return bookList?.data?.list.map( (book)=>{
            return(
                <li key={book.isbn}>
                    <Link to={`/${school}/book/${book.isbn}${location.search}`} >
                        <BookListItem book={book} />
                    </Link>
                </li>
            )
        });
    }, [bookList, error, isError, location.search, school]);

    return (
        <div className="subpage">
            <div id="contents" className="find_book">
                <BookSearchOption bookCount={bookList?.data?.totalElements} />

                <div className="inner">
                    <div className="section">
                        <div className="book_list">
                            { bookList?.data?.list.length>0 &&
                            <ul className="sorts">
                                <li className={searchOption.sort==='createdAt,desc'?'active':''}>
                                    <button onClick={()=>gotoPage(0, {sort:'createdAt,desc'})}>도서등록순</button>
                                </li>
                                <li className={searchOption.sort==='readingCount,desc'?'active':''}>
                                    <button onClick={()=>gotoPage(0, {sort:'readingCount,desc'})}>독서활동순</button>
                                </li>
                            </ul>
                            }
                            <ul>
                                {BookListElements}
                            </ul>
                        </div>
                        <Pagination page={bookList?.data?.page} totalPage={bookList?.data?.totalPages} gotoPage={gotoPage} />
                        <Loading overlay={true} active={isFetching} />
                    </div>
                </div>
            </div>
        </div>
    );
};